/* PDP only (loaded by sections/main-product.liquid): smooth open / close of the collapsible rows (<details> has no animation of its own); only one row stays open at a time */

// same curve as cubic-bezier(0.4, 0, 0.2, 1)
function pdpEase(t) {
  var x1 = 0.4, y1 = 0, x2 = 0.2, y2 = 1;
  var low = 0, high = 1, mid = 0.5;
  for (var i = 0; i < 20; i++) {
    mid = (low + high) / 2;
    var x = 3 * (1 - mid) * (1 - mid) * mid * x1 + 3 * (1 - mid) * mid * mid * x2 + mid * mid * mid;
    if (x < t) low = mid;
    else high = mid;
  }
  return 3 * (1 - mid) * (1 - mid) * mid * y1 + 3 * (1 - mid) * mid * mid * y2 + mid * mid * mid;
}

// An element that something else styles with !important (the Frequently Bought widget) cannot be animated with the
// Web Animations API: !important beats animations. So its size is stepped by hand with inline !important values.
function pdpTween(element, opening, onFinish) {
  var style = getComputedStyle(element);
  var properties = { height: 'height', paddingTop: 'padding-top', paddingBottom: 'padding-bottom', borderTopWidth: 'border-top-width', borderBottomWidth: 'border-bottom-width', marginBottom: 'margin-bottom' };
  var full = {};
  Object.keys(properties).forEach(function (name) {
    full[name] = name === 'height' ? element.getBoundingClientRect().height : parseFloat(style[name]) || 0;
  });
  var start = performance.now();
  var duration = 700;
  var frame;
  var finished = false;

  function clear() {
    Object.keys(properties).forEach(function (name) { element.style.removeProperty(properties[name]); });
    element.style.removeProperty('overflow');
    element.style.opacity = '';
  }

  function step(now) {
    var progress = Math.min((now - start) / duration, 1);
    var amount = pdpEase(progress);
    var value = opening ? amount : 1 - amount;
    Object.keys(properties).forEach(function (name) {
      element.style.setProperty(properties[name], full[name] * value + 'px', 'important');
    });
    element.style.setProperty('overflow', 'hidden', 'important');
    element.style.opacity = value;
    if (progress < 1) {
      frame = requestAnimationFrame(step);
    } else {
      finished = true;
      clear();
      onFinish();
    }
  }

  step(start);
  return {
    cancel: function () {
      if (finished) return;
      cancelAnimationFrame(frame);
      clear();
    },
  };
}

function pdpAccordionToggle(details, opening) {
  // a row can also open / close something outside of it (data-target), e.g. the widget an app draws right after the row
  var external = !!details.dataset.target;
  var content = external ? document.querySelector(details.dataset.target) : details.querySelector('.accordion__content');
  if (!content) {
    details.open = opening;
    return;
  }

  if (details.animation) details.animation.cancel();

  if (opening) details.open = true;
  details.classList.toggle('pdp-accordion-closing', !opening);

  function finish() {
    details.animation = null;
    content.style.overflow = '';
    if (!opening) details.open = false;
    details.classList.remove('pdp-accordion-closing');
  }

  if (external) {
    var tween = pdpTween(content, opening, finish);
    details.animation = tween;
    return;
  }

  var gap = getComputedStyle(content).marginBottom;
  var height = content.offsetHeight + 'px';
  var animation = content.animate(
    {
      height: opening ? ['0px', height] : [height, '0px'],
      marginBottom: opening ? ['0px', gap] : [gap, '0px'],
      opacity: opening ? [0, 1] : [1, 0],
    },
    { duration: 700, easing: 'cubic-bezier(0.4, 0, 0.2, 1)' }
  );
  details.animation = animation;
  content.style.overflow = 'hidden';

  animation.onfinish = animation.oncancel = function () {
    if (details.animation !== animation) return;
    finish();
  };
}

document.addEventListener('click', function (event) {
  var summary = event.target.closest('.product__accordion summary');
  if (!summary) return;

  var details = summary.parentElement;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var opening = !details.open || details.classList.contains('pdp-accordion-closing');

  if (opening) {
    document.querySelectorAll('.product__accordion details[open]').forEach(function (other) {
      if (other === details || other.classList.contains('pdp-accordion-closing')) return;
      if (reduceMotion) other.open = false;
      else pdpAccordionToggle(other, false);
    });
  }

  if (reduceMotion) return; // native open / close
  event.preventDefault();
  pdpAccordionToggle(details, opening);
});
